export default ({ buttons }) => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  action: {
    margin: [0, 20, 0, 0],
    [`@media (max-width: ${buttons.breakpoint}px)`]: {
      margin: 0,
      width: '100%'
    }
  },
  button: {
    [`@media (max-width: ${buttons.breakpoint}px)`]: {
      width: '100%',
      borderRadius: '0'
    }
  }
});
